import { Button, Col, Dropdown, Text } from 'components';
import { sports } from 'lib';
import React from 'react';

const Item = ({ sport, setSport, team, setTeam, athlete, setAthlete, index }) => {
  const sportsObject = sports.find((x) => x.name === sport);

  const sportsTeam = sportsObject && sportsObject?.teams?.find((x) => x.value === team),
    players = (sportsObject && sportsTeam?.players) || sportsObject?.players;

  return (
    <Col marg={index && '18px 0 0'} wid="100%">
      <Dropdown
        title="Sport"
        admin
        translatePrefix="sports"
        options={sports}
        selected={sport}
        rounded
        handleSelect={setSport}
        placeholder="Select..."
        wid="100%"
        bg="#fff"
      />

      {sportsObject?.teams && !!sportsObject.teams?.length && (
        <React.Fragment>
          <Dropdown
            title="Team"
            marg="8px 0 0"
            admin
            rounded
            options={sportsObject.teams}
            wid="100%"
            selected={team}
            placeholder="Select..."
            bg="#fff"
            handleSelect={setTeam}
          />
        </React.Fragment>
      )}

      {players && !!players?.length && (
        <React.Fragment>
          <Text marg="8px 16px 4px" b2 med>
            Athlete
          </Text>

          <Dropdown
            admin
            rounded
            options={players}
            selected={athlete}
            placeholder="Select..."
            wid="100%"
            bg="#fff"
            handleSelect={setAthlete}
          />
        </React.Fragment>
      )}
    </Col>
  );
};

const FavoriteSports = ({ data, setData }) => {
  function handleSportSelect(e, idx) {
    setData(
      data.map((x, i) => {
        if (i !== idx) return x;

        return {
          sport: e.name
        };
      })
    );
  }

  function handleFavoriteSelect(e, idx, type) {
    setData(
      data.map((x, i) => {
        if (i !== idx) return x;

        if (type === 'Team') return { ...x, favoriteTeam: e.value, favoritePlayer: null };

        return { ...x, favoritePlayer: e };
      })
    );
  }

  function addRow() {
    setData([...data, { sport: '' }]);
  }

  return (
    <Col marg="40px 0 0" noFlex wid="100%">
      <Text marg="0" h4 bold>
        Favorite sports
      </Text>

      <Col noFlex wid="100%" marg="24px 0 0">
        {data.map((x, i) => (
          <Item
            key={i}
            index={i}
            sport={x.sport}
            setSport={(e) => handleSportSelect(e, i)}
            team={x.favoriteTeam}
            setTeam={(e) => handleFavoriteSelect(e, i, 'Team')}
            athlete={x.favoritePlayer}
            setAthlete={(e) => handleFavoriteSelect(e, i, 'Player')}
          />
        ))}
      </Col>

      {!!data[data.length - 1]?.sport && (
        <Button text="Add sport" onClick={addRow} marg="24px 0 0" icon="add" wid="100%" bordered />
      )}
    </Col>
  );
};

export default FavoriteSports;
